<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

let searchParams = new URLSearchParams(window.location.search)
  let cartOpen = searchParams.has('cart_show');

  if(cartOpen){
    $(document.body).addClass('cart-sidebar-show');
  }
